import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

/* ─────────────────────────────────────────
   ⬇️ MODIFIABLE — Nom de votre entreprise
   ───────────────────────────────────────── */
const COMPANY_NAME = "SlimeTech";

const NAV_LINKS = [
  { id: "hero",     label: "Accueil"  },
  { id: "services", label: "Services" },
  { id: "contact",  label: "Contact"  },
];

const Header = () => {
  const [scrolled,   setScrolled]   = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "";

  /* Effet shadow au scroll */
  const onScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  /* Bloquer le scroll du body quand le menu mobile est ouvert */
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [mobileOpen]);

  const closeMenu  = () => setMobileOpen(false);
  const toggleMenu = () => setMobileOpen(v => !v);

  /* Navigation intelligente : scroll si on est sur la home, redirect sinon */
  const handleNav = useCallback((e, sectionId) => {
    e.preventDefault();
    closeMenu();
    if (isHome) {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = `/#${sectionId}`;
    }
  }, [isHome]);

  /* Sur les pages internes, le header est toujours opaque (fond + scrolled) */
  const headerClass = [
    "p-header",
    scrolled || !isHome ? "scrolled" : "",
    !isHome             ? "p-header--inner" : "",
  ].filter(Boolean).join(" ");

  return (
    <>
      {/* ─── Header sticky ─── */}
      <header className={headerClass}>
        <div className="p-header-inner">

          {/* Logo */}
          <a
            href="/"
            className="p-logo"
            onClick={(e) => {
              e.preventDefault();
              closeMenu();
              if (isHome) {
                window.scrollTo({ top: 0, behavior: "smooth" });
              } else {
                window.location.href = "/";
              }
            }}
          >
            <img
              src="/images/logo-slime-tech.png"
              alt={`${COMPANY_NAME} — Développeur web freelance`}
              className="p-logo-img"
              width="120"
              height="40"
              loading="eager"
            />
          </a>

          {/* Navigation desktop */}
          <nav className="p-nav" aria-label="Navigation principale">
            {NAV_LINKS.map(({ id, label }) => (
              <a
                key={id}
                href={`/#${id}`}
                className="p-nav-link"
                onClick={(e) => handleNav(e, id)}
              >
                {label}
              </a>
            ))}
            <a
              href="/#contact"
              className="btn-p btn-p--primary"
              style={{ padding: ".58rem 1.4rem", fontSize: ".88rem" }}
              onClick={(e) => handleNav(e, "contact")}
            >
              Me contacter
            </a>
          </nav>

          {/* Burger mobile */}
          <button
            className={`p-burger${mobileOpen ? " open" : ""}`}
            onClick={toggleMenu}
            aria-label={mobileOpen ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={mobileOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      {/* ─── Drawer navigation mobile ─── */}
      <nav
        className={`p-mobile-nav${mobileOpen ? " open" : ""}`}
        aria-label="Menu mobile"
      >
        {NAV_LINKS.map(({ id, label }) => (
          <a key={id} href={`/#${id}`} onClick={(e) => handleNav(e, id)}>
            {label}
          </a>
        ))}
        <a
          href="/#contact"
          className="btn-p btn-p--primary"
          onClick={(e) => handleNav(e, "contact")}
          style={{ marginTop: "1rem" }}
        >
          Me contacter
        </a>
      </nav>
    </>
  );
};

export default Header;
